import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import styled from 'styled-components';

import { BaseComponent } from 'components/BaseComponent';

import {hideWarning, removeApiError} from '../actions';
import { selectErrors } from '../selectors';
import { Button } from '../../../components/Buttons';
import { HBox } from '../../../components/Box';
import { REQUEST_API_KEY } from '../constants';

const Container = styled.div`
  padding: 12px;

  width: 100%;
  border: 1px solid red;
  background-color: #ffeaea;
  z-index: 2;
  position: ${props => props.static ? 'static' : 'absolute'};
  top: 0;
  left: 0;
`;
/* eslint-disable react/prefer-stateless-function */
class WarningsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  renderWarning(message) {
    return (
      <div className="error">
        <HBox vCenter>
          <div className="label">{message}</div>
          <Button small onClick={() => this.props.hideWarning()}>
            x
          </Button>
        </HBox>
      </div>
    );
  }

  render() {
    return (
      <Container static={this.props.static}>
        <div className="general errors">{this.renderWarning(this.props.message)}</div>
      </Container>
    );
  }
}

WarningsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    errors: selectErrors(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Warnings = compose(withConnect)(WarningsComp);
